<template>
  <i class="ph-bold ph-warning text-red-5" />
</template>
